const icons = {};

icons.expectedFeedback = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="24" height="24" fill="white" />
  <path d="M4.39429 9.51233C5.44039 6.31201 8.45017 4 12 4C15.6614 4 18.7484 6.45976 19.6985 9.81697L18.0376 10.2457C17.2783 7.6279 14.8626 5.71429 12 5.71429C9.25706 5.71429 6.92451 7.47115 6.06621 9.92096L4.39429 9.51233Z" fill="#F29C38" />
  <path d="M12 18.2857C9.12533 18.2857 6.7014 16.356 5.95286 13.7214L4.29049 14.144C5.22765 17.5212 8.32432 20 12 20C15.5508 20 18.5613 17.6866 19.6065 14.4849L17.9383 14.0659C17.0837 16.5226 14.7477 18.2857 12 18.2857Z" fill="#F29C38" />
  <path d="M7.95269 13.6281L2.41083 15.0212L4.48519 11.5537L7.95269 13.6281Z" fill="#F29C38" />
  <path d="M16.0496 10.4401L21.5938 9.0564L19.5136 12.5204L16.0496 10.4401Z" fill="#F29C38" />
</svg>



export default icons;